import React, { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'

import { AppLayout, FormWrapper, LanguageSelector, Modal } from '@/components'
import { ICar } from '@/types'
import { t } from '@/i18n'

import Form from './form'
import History from './history'
import { useData } from './useData'

const EditCar: React.FC = () => {
  const { id = '' } = useParams()
  const [isEditing, setIsEditing] = useState<boolean>(true)
  const [showHistory, setShowHistory] = useState<boolean>(false)
  const { data, loading, submitting, onSubmit } = useData({ id })

  const onSubmitForm = useCallback(
    (d: ICar) => {
      delete d.activeDeal
      onSubmit(`cars/${id}/`, true, () => setIsEditing(false))(d)
    },
    [id, onSubmit],
  )

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <FormWrapper
        breadcrumbs={[{ name: isEditing ? 'edit_car' : 'view_car' }]}
        loading={loading}
        isEditing={isEditing}
        onEdit={() => setIsEditing(true)}
        extraButtons={[
          {
            text: t('car_positions'),
            className: 'success deal-history-button',
            onClick: () => setShowHistory(true),
          },
        ]}
      >
        <div className="content-box">
          <div className="scroll-wrap">
            <div className="content-title">
              <h2>
                {isEditing
                  ? t('edit_car_label', { label: data.number })
                  : t('view_car')}
              </h2>
            </div>
            {data?.id && (
              <Form
                isEditing={isEditing}
                initialData={data}
                loading={loading}
                submitting={submitting}
                onCancel={() => setIsEditing(false)}
                onSubmit={onSubmitForm}
              />
            )}
          </div>
        </div>
      </FormWrapper>
      {showHistory && (
        <Modal
          className="car-positions"
          visible
          title={t('car_positions')}
          onClose={() => setShowHistory(false)}
        >
          <History id={data?.id} carId={id} />
        </Modal>
      )}
    </AppLayout>
  )
}

export default EditCar
